module.exports = __webpack_public_path__ + "static/media/thumb3.6802e8dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb3.jpg
// module id = 642
// module chunks = 0